import { LoggerConfig } from '../types/LoggerConfig';

/**
 * @group Constants
 * 
 * @summary
 * <blockquote>Auto-generated logger configuration</blockquote>
 * 
 * @remarks
 * Critical domains (auth, user, role, tenant) are enabled in all environments.
 * Other domains are enabled only in development by default.
 * 
 * You can modify these settings during development to customize logging.
 * 
 * @example
 * ```typescript
 * const isAuthEnabled = LOGGER_CONFIG.domains.auth.development;
 * const logLevel = LOGGER_CONFIG.levels.development;
 * ```
 **/
export const LOGGER_CONFIG: LoggerConfig = {
  levels: {
    development: 'debug',
    preview: 'info', 
    production: 'warn',
  },
  domains: {
    'api': {
      development: true,
      preview: false,
      production: false,
    },
    'auth': {
      development: true,
      preview: true,
      production: true,
    },
    'contentinteraction': {
      development: true,
      preview: false,
      production: false,
    },
    'contentsection': {
      development: true,
      preview: false,
      production: false,
    },
    'dashboard': {
      development: true,
      preview: false,
      production: false,
    },
    'data': {
      development: true,
      preview: false,
      production: false,
    },
    'learningmodule': {
      development: true,
      preview: false,
      production: false,
    },
    'learningmodulephase': {
      development: true,
      preview: false,
      production: false,
    },
    'learningphase': {
      development: true,
      preview: false,
      production: false,
    },
    'learningphasetask': {
      development: true,
      preview: false,
      production: false,
    },
    'learningprerequisite': {
      development: true,
      preview: false,
      production: false,
    },
    'learningprogres': {
      development: true,
      preview: false,
      production: false,
    },
    'learningquizattempt': {
      development: true,
      preview: false,
      production: false,
    },
    'learningquizquestion': {
      development: true,
      preview: false,
      production: false,
    },
    'learningquizze': {
      development: true,
      preview: false,
      production: false,
    },
    'learningsectioncontent': {
      development: true,
      preview: false,
      production: false,
    },
    'learningtag': {
      development: true,
      preview: false,
      production: false,
    },
    'learningtask': {
      development: true,
      preview: false,
      production: false,
    },
    'learningtaskasset': {
      development: true,
      preview: false,
      production: false,
    },
    'learningtaskassetlink': {
      development: true,
      preview: false,
      production: false,
    },
    'learningtaskquizze': {
      development: true,
      preview: false,
      production: false,
    },
    'learningtasksection': {
      development: true,
      preview: false,
      production: false,
    },
    'learningtasksectionlink': {
      development: true,
      preview: false,
      production: false,
    },
    'learningtasktag': {
      development: true,
      preview: false,
      production: false,
    },
    'learningtaskversion': {
      development: true,
      preview: false,
      production: false,
    },
    'role': {
      development: true,
      preview: true,
      production: true,
    },
    'roleresourcepermission': {
      development: true,
      preview: true,
      production: true,
    },
    'sectioncontent': {
      development: true,
      preview: false,
      production: false,
    },
    'tenant': {
      development: true,
      preview: true,
      production: true,
    },
    'user': {
      development: true,
      preview: true,
      production: true,
    },
    'userrole': {
      development: true,
      preview: true,
      production: true,
    },
    'users': {
      development: true,
      preview: true,
      production: true,
    },
  } as const,
};
